import API_ENDPOINTS from '../api-endpoints';
import { adminAuthAxios, pureAxios } from '../axios';
import {
  CommentListParmasType,
  CommentListType,
  CommentPostType,
  PatchCommentParmsType,
} from './types';

/**
 * POST
 * /comment
 * 회원 댓글 등록 API
 */

export const postComment = async (body: CommentPostType) => {
  const res = await adminAuthAxios.post(`${API_ENDPOINTS.COMMENT}`, body);
  return res.data.data;
};

/**
 * GET
 * /comment/{category}/{foreignIdx}
 * 댓글 리스트 조회 API
 */

export const getCommentListByCategoryForeignIdx = async ({
  category,
  foreignIdx,
  order = 'created_at:DESC',
  take = 10,
  page = 1,
}: Partial<CommentListParmasType>): Promise<CommentListType> => {
  const params = { take, page, order };
  const res = await pureAxios.get(
    `${API_ENDPOINTS.COMMENT_LIST}${category}/${foreignIdx}`,
    {
      params,
    },
  );
  return res.data;
};

/**
 * PATCH
 * /comment/{idx}
 * 회원 댓글 수정 API
 */
export const patchCommentContents = async (
  commentIdx: string,
  body: PatchCommentParmsType,
) => {
  const res = await adminAuthAxios.patch(
    `${API_ENDPOINTS.COMMENT_UPDATE}${commentIdx}`,
    body,
  );
  return res.data;
};

/**
 * DELETE
 * /comment/{idx}
 * 회원 댓글 삭제 API
 */
export const deleteComment = async (commentIdx: string) => {
  const res = await adminAuthAxios.delete(
    `${API_ENDPOINTS.COMMENT_DELETE}${commentIdx}`,
  );
  return res.data;
};
